import React from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from "prop-types";

export default class WebMediaQuery extends React.Component {

  static propTypes = {
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    largeDesktopOnly: PropTypes.bool,
  };

  render() {

    let {
      mobileOnly,
      desktopOnly,
      largeDesktopOnly,
    } = this.props;

    let query = "screen";

    if (largeDesktopOnly) {
      query="screen and (min-width : 1024px)"
    }

    if (desktopOnly) {
      query="screen and (min-width : 769px)"
    }

    if (mobileOnly) {
      query="screen and (max-width : 768px)"
    }

    return (
      <MediaQuery query={query}>
        {this.props.children}
      </MediaQuery>
    )
  }

}